module.exports = __webpack_public_path__ + "static/media/podcast-episode-9.9c6d01ef.md";